// extracted by mini-css-extract-plugin
module.exports = {"layoutsContainer":"Layouts_layoutsContainer__15L9m","layoutOptionContainer":"Layouts_layoutOptionContainer__1-yqp","switch":"Layouts_switch__2ons6"};